// removed by extract-text-webpack-plugin
module.exports = {"row":"about-module__row___BVzga","leftContent":"about-module__leftContent___2-uEz","img":"about-module__img___jx8a0","rightContent":"about-module__rightContent___3JR-0","markdown":"about-module__markdown___295Mu","markdownButton":"about-module__markdownButton___VR-tg","violetBox":"about-module__violetBox___3XLII"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/about/about.module.scss
// module id = 248
// module chunks = 0